/* eslint-disable prefer-rest-params */
import { h, render } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { useSelector, useDispatch, batch } from 'react-redux'
import { lazy, Suspense } from 'preact/compat'
import { modelTypes } from 'constants'

import UINavbar from '@ui/Navbar'

import { wishlistSelector } from '@state/wishlist/wishlistSelectors'
import { cartSelector } from '@state/cart/cartSelectors'

import { requestGetWishlist } from '@state/wishlist/wishlistSlice'
import { requestGetCart } from '@state/cart/cartSlice'

import withProvider from '@state/withProvider'
import translate from '@core/hooks/useResource'
import { useSize } from '@utils/dom'
import useSSR from '@core/hooks/useSSR'

import QuickSearch from '@features/elastic/search/QuickSearch'

function Navbar() {
	const {
		navbarHeaderLinks,
		// navbarLanguages, // !Note disabled for this project
		navbarMenu,
		navbarVat,
		navbarLogo,
		navbarSearchBox,
		navbarMotivators,
		className,
		menu,
	} = useSSR([
		modelTypes.navbarHeaderLinks,
		modelTypes.navbarMenu,
		modelTypes.navbarSearchBox,
		modelTypes.navbarVat,
		modelTypes.navbarLogo,
		modelTypes.navbarMotivators,
		modelTypes.initialState,
		modelTypes.criticalState,
	])

	const logoOptions = {
		...navbarLogo,
		width: 193,
		height: 50,
		aspectRatio: '193/50',
	}

	const dispatch = useDispatch()
	const { isDesktop } = useSize()

	const { quantity: wishlistQuantity } = useSelector(wishlistSelector)
	const { cartQuantity } = useSelector(cartSelector)
	const { routes } = useSSR([modelTypes.routes])

	const links = {
		account: {
			text: translate('topmenu.account'),
			url: routes.customer.info,
		},
		addresses: {
			text: translate('topmenu.addresses'),
			url: routes.customer.addresses,
		},
		orders: {
			text: translate('topmenu.orders'),
			url: routes.customer.orders,
		},
		logout: {
			text: translate('topmenu.logout'),
			url: routes.customer.logout,
		},
	}

	useEffect(() => {
		batch(async () => {
			await dispatch(requestGetCart())
			await dispatch(requestGetWishlist())
		})
	}, [])

	return (
		<UINavbar
			className={className}
			headerLinks={navbarHeaderLinks}
			vat={navbarVat}
			motivators={navbarMotivators}
			logo={logoOptions}
			MenuComponent={null}
			isDesktop={isDesktop}
			search={navbarSearchBox}
			SearchComponent={<QuickSearch />}
			cartQuantity={cartQuantity}
			wishlistQuantity={wishlistQuantity}
			customerLinks={links}
			showSearchAsIcon={false}
			showMenuAsIcon={false}
			sticky
		/>
	)
}

export default withProvider(Navbar)
